<template>
  <CommonMap
    :city="city"
    :fit-view-priority="fitViewPriority"
    :avoid="[20, 20, 20, 20]"
    :animate-enable="false"
    :rotate-enable="false"
    :map-style="mapStyle"
    view-mode="3D"
  >
    <slot />
  </CommonMap>
</template>

<script>
const defaultMapStyle = 'amap://styles/b84f8389e220c3ecaec3741d6d3070a8';

export default {
  name: 'MapContainer',
  props: {
    city: {
      type: String,
      required: false,
      default: undefined
    },
    fitViewPriority: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      mapStyle: defaultMapStyle
    };
  }
};
</script>
